<template>
  <div class="ais-Highlight" v-html="innerHtml"></div>
</template>

<script>
function getPropertyByPath(object, path) {
  const parts = path.split(".");

  return parts.reduce((current, key) => current && current[key], object);
}

const htmlEscapes = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

const regexUnescapedHtml = /[&<>"']/g;

// make sure escape can be done only once, by doing it per hihglight component
function escapeHtml(html) {
  return html.replace(
    regexUnescapedHtml,
    (character) => htmlEscapes[character]
  );
}

export default {
  props: {
    hit: {
      type: Object,
      required: true,
    },
    attribute: {
      type: String,
      required: true,
    },
  },
  computed: {
    innerHtml() {
      const highlight = getPropertyByPath(
        this.hit._highlightResult,
        this.attribute
      );
      return escapeHtml(highlight ? highlight.value : "")
        .replace(/__highlight__/g, "<mark>")
        .replace(/__\/highlight__/g, "</mark>");
    },
  },
};
</script>
